import dateValidator from "./dateValidator";
import stringValidator from "./stringValidator";
import numberValidator from "./numberValidator";
import yearValidator from "./yearValidator";
import minAgeValidator from "./minAgeValidator";
import maxAgeValidator from "./maxAgeValidator";
import medianAgeValidator from "./medianAgeValidator";
import phoneValidator from "./phoneValidator";
import urlValidator from "./urlValidator";
import emailValidator from "./emailValidator";
export default {
  dateValidator,
  stringValidator,
  numberValidator,
  yearValidator,
  minAgeValidator,
  maxAgeValidator,
  medianAgeValidator,
  phoneValidator,
  urlValidator,
  emailValidator,
};
